export default __webpack_public_path__ + "static/2-7da029599707c498a33a6b47dc12ef7b.png";